/**
 * Garde Envoi d'e-mails pour le mode démonstration.
 * En démo, toute tentative d'envoi d'e-mail est bloquée et affiche une modale
 * d'information centrée (même mécanisme que la garde KITT).
 *
 * Usage :
 *   const guardEmail = useEmailGuard();
 *   const onSend = () => { if (guardEmail()) return; ...envoyer... };
 */
import { useCallback } from 'react';
import { useIsDemo } from './useIsDemo';

export const EMAIL_DEMO_EVENT = 'email-demo-blocked';

export const openEmailDemoNotice = () => {
  window.dispatchEvent(new CustomEvent(EMAIL_DEMO_EVENT));
};

export const useEmailGuard = () => {
  const isDemo = useIsDemo();
  return useCallback(() => {
    if (isDemo) {
      openEmailDemoNotice();
      return true;
    }
    return false;
  }, [isDemo]);
};
